import { useEffect, useRef } from 'react'
import { toast } from 'sonner'
import { useT } from '@/i18n/I18nProvider'

// Hash do bundle que ESTÁ rodando agora (lido da própria tag <script> do Vite).
const RUNNING =
  [...document.scripts]
    .map((s) => s.getAttribute('src') || '')
    .find((s) => /\/assets\/index-[\w-]+\.js/.test(s)) ?? ''

// Busca o index.html do servidor (sem cache) e extrai o bundle atual publicado.
async function fetchLatest(): Promise<string> {
  const res = await fetch('/', { cache: 'no-store' })
  const html = await res.text()
  return html.match(/\/assets\/index-[\w-]+\.js/)?.[0] ?? ''
}

// Detecta deploy novo sem a pessoa precisar dar refresh manual (Ctrl+Shift+R).
// A cada minuto (e ao voltar o foco na aba) compara o bundle rodando com o
// publicado; se mudou, mostra um toast persistente com botão "Atualizar".
export function VersionWatcher() {
  const { t } = useT()
  const notified = useRef(false)

  useEffect(() => {
    if (!RUNNING) return // dev server / build sem hash: nada a vigiar
    let alive = true

    async function check() {
      if (notified.current || document.hidden) return
      try {
        const latest = await fetchLatest()
        if (!alive || !latest || latest === RUNNING) return
        notified.current = true
        toast(t('app.updateTitle'), {
          description: t('app.updateDesc'),
          action: { label: t('app.updateAction'), onClick: () => window.location.reload() },
          duration: Infinity,
        })
      } catch {
        /* offline ou erro de rede: ignora, tenta de novo depois */
      }
    }

    const id = window.setInterval(check, 60_000)
    const onVisible = () => {
      if (!document.hidden) void check()
    }
    document.addEventListener('visibilitychange', onVisible)
    void check()

    return () => {
      alive = false
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [t])

  return null
}
